import { createElementVNode as _createElementVNode, createTextVNode as _createTextVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, createVNode as _createVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, renderList as _renderList, Fragment as _Fragment, createCommentVNode as _createCommentVNode, toDisplayString as _toDisplayString, withModifiers as _withModifiers, normalizeClass as _normalizeClass, TransitionGroup as _TransitionGroup, resolveDirective as _resolveDirective, withDirectives as _withDirectives, createBlock as _createBlock, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-ade3ba20"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "alerts__container" }
const _hoisted_2 = { class: "dt-card alerts__list" }
const _hoisted_3 = { class: "dt-card__heading" }
const _hoisted_4 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("h2", { class: "dt-card__heading-title" }, "Recent Alerts", -1))
const _hoisted_5 = { class: "dt-card__body" }
const _hoisted_6 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("svg", {
  class: "dt-icon",
  viewBox: "0 0 24 24"
}, [
  /*#__PURE__*/_createElementVNode("path", { d: "M9.5,3A6.5,6.5 0 0,1 16,9.5C16,11.11 15.41,12.59 14.44,13.73L14.71,14H15.5L20.5,19L19,20.5L14,15.5V14.71L13.73,14.44C12.59,15.41 11.11,16 9.5,16A6.5,6.5 0 0,1 3,9.5A6.5,6.5 0 0,1 9.5,3M9.5,5C7,5 5,7 5,9.5C5,12 7,14 9.5,14C12,14 14,12 14,9.5C14,7 12,5 9.5,5Z" })
], -1))
const _hoisted_7 = {
  key: 0,
  class: "dt-list"
}
const _hoisted_8 = {
  key: 0,
  class: "dt-list__status"
}
const _hoisted_9 = { class: "dt-list__content" }
const _hoisted_10 = { class: "dt-list__title" }
const _hoisted_11 = { class: "dt-list__sub-title" }
const _hoisted_12 = { class: "time" }
const _hoisted_13 = ["onClick"]
const _hoisted_14 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("svg", {
  class: "dt-icon",
  viewBox: "0 0 24 24"
}, [
  /*#__PURE__*/_createElementVNode("path", { d: "M19,6.41L17.59,5L12,10.59L6.41,5L5,6.41L10.59,12L5,17.59L6.41,19L12,13.41L17.59,19L19,17.59L13.41,12L19,6.41Z" })
], -1))
const _hoisted_15 = [
  _hoisted_14
]
const _hoisted_16 = {
  key: 1,
  class: "alerts__no-search-results"
}
const _hoisted_17 = ["src"]
const _hoisted_18 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", null, "No alerts match search", -1))
const _hoisted_19 = {
  key: 1,
  class: "empty-message"
}
const _hoisted_20 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", null, "No Recent Alerts", -1))
const _hoisted_21 = [
  _hoisted_20
]
const _hoisted_22 = {
  key: 2,
  class: "mt-5"
}
const _hoisted_23 = { class: "dt-card__heading" }
const _hoisted_24 = { class: "dt-card__heading-content" }
const _hoisted_25 = { class: "dt-card__heading-title" }
const _hoisted_26 = {
  key: 1,
  class: "dt-card__heading-title--none"
}
const _hoisted_27 = {
  ref: "alertDetailsBody",
  class: "dt-card__body"
}
const _hoisted_28 = { class: "row mb-1" }
const _hoisted_29 = { key: 0 }
const _hoisted_30 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("h1", { class: "alert-active" }, "ACTIVE", -1))
const _hoisted_31 = [
  _hoisted_30
]
const _hoisted_32 = { key: 1 }
const _hoisted_33 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("h1", { class: "alert-inactive" }, "INACTIVE", -1))
const _hoisted_34 = [
  _hoisted_33
]
const _hoisted_35 = { class: "row" }
const _hoisted_36 = { class: "col-lg-6" }
const _hoisted_37 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", null, "The alert title is displayed at the top of the alert screen in Ditto Receiver.", -1))
const _hoisted_38 = { class: "col-lg-6" }
const _hoisted_39 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", null, "The severity of the alert will display in Ditto Receiver.", -1))
const _hoisted_40 = { class: "row" }
const _hoisted_41 = { class: "col-lg-6" }
const _hoisted_42 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", null, "When this alert will begin showing in Ditto Receiver.", -1))
const _hoisted_43 = { class: "col-lg-6" }
const _hoisted_44 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", null, "When this alert will expire and stop showing in Ditto Receiver.", -1))
const _hoisted_45 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "row" }, [
  /*#__PURE__*/_createElementVNode("div", { class: "col-lg-6" }, " ")
], -1))
const _hoisted_46 = { class: "row" }
const _hoisted_47 = { class: "col-lg-6" }
const _hoisted_48 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", null, "The description of the alert in Ditto Receiver.", -1))
const _hoisted_49 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "col-lg-6" }, null, -1))
const _hoisted_50 = { class: "callout callout--informational callout--no-max mb-4" }
const _hoisted_51 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", null, [
  /*#__PURE__*/_createElementVNode("span", null, [
    /*#__PURE__*/_createTextVNode("You can specify a combination of "),
    /*#__PURE__*/_createElementVNode("strong", null, "Rooms"),
    /*#__PURE__*/_createTextVNode(" and "),
    /*#__PURE__*/_createElementVNode("strong", null, "Locations"),
    /*#__PURE__*/_createTextVNode(" to receive this alert.")
  ]),
  /*#__PURE__*/_createElementVNode("span", null, [
    /*#__PURE__*/_createTextVNode("If a "),
    /*#__PURE__*/_createElementVNode("strong", null, "Room"),
    /*#__PURE__*/_createTextVNode(" is part of a "),
    /*#__PURE__*/_createElementVNode("strong", null, "Location"),
    /*#__PURE__*/_createTextVNode(" it will be alerted only once. All "),
    /*#__PURE__*/_createElementVNode("strong", null, "Sublocations"),
    /*#__PURE__*/_createTextVNode(" of a "),
    /*#__PURE__*/_createElementVNode("strong", null, "Location"),
    /*#__PURE__*/_createTextVNode(" will receive the alert.")
  ])
], -1))
const _hoisted_52 = { class: "row" }
const _hoisted_53 = { class: "col-lg-6" }
const _hoisted_54 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", null, "Rooms that will receive this alert.", -1))
const _hoisted_55 = { class: "col-lg-6" }
const _hoisted_56 = { key: 0 }
const _hoisted_57 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", null, "Locations that will receive this alert.", -1))
const _hoisted_58 = { class: "row" }
const _hoisted_59 = { class: "col-lg-6" }
const _hoisted_60 = { class: "code" }
const _hoisted_61 = { class: "col-lg-6" }
const _hoisted_62 = { class: "row" }
const _hoisted_63 = { class: "col-lg-6" }
const _hoisted_64 = { key: 0 }
const _hoisted_65 = { key: 1 }
const _hoisted_66 = { class: "col-lg-6" }
const _hoisted_67 = { key: 0 }
const _hoisted_68 = { key: 1 }
const _hoisted_69 = { class: "row" }
const _hoisted_70 = { class: "col-lg-6" }
const _hoisted_71 = { key: 0 }
const _hoisted_72 = { key: 1 }
const _hoisted_73 = {
  key: 1,
  class: "alerts__details-loading"
}
const _hoisted_74 = {
  key: 2,
  class: "alerts__select-alert"
}
const _hoisted_75 = {
  key: 0,
  class: "mb-2"
}
const _hoisted_76 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("p", null, "Select an alert to view details or press \"New Alert\" to create a new alert.", -1))

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_el_button = _resolveComponent("el-button")!
  const _component_router_link = _resolveComponent("router-link")!
  const _component_el_input = _resolveComponent("el-input")!
  const _component_el_tooltip = _resolveComponent("el-tooltip")!
  const _component_el_form_item = _resolveComponent("el-form-item")!
  const _component_el_option = _resolveComponent("el-option")!
  const _component_el_select = _resolveComponent("el-select")!
  const _component_VueDatePicker = _resolveComponent("VueDatePicker")!
  const _component_el_divider = _resolveComponent("el-divider")!
  const _component_Icon = _resolveComponent("Icon")!
  const _component_el_form = _resolveComponent("el-form")!
  const _component_ModelSelector = _resolveComponent("ModelSelector")!
  const _component_TierLimit = _resolveComponent("TierLimit")!
  const _directive_loading = _resolveDirective("loading")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createElementVNode("section", _hoisted_2, [
      _createElementVNode("div", _hoisted_3, [
        _hoisted_4,
        _createVNode(_component_router_link, { to: "/alerts/new" }, {
          default: _withCtx(() => [
            _createVNode(_component_el_button, { type: "primary" }, {
              default: _withCtx(() => [
                _createTextVNode("New Alert")
              ]),
              _: 1
            })
          ]),
          _: 1
        })
      ]),
      _createElementVNode("div", _hoisted_5, [
        (_ctx.allEmergencyAlerts && _ctx.allEmergencyAlerts.length && !_ctx.isAlertsLoading)
          ? (_openBlock(), _createElementBlock(_Fragment, { key: 0 }, [
              _createVNode(_component_el_input, {
                modelValue: _ctx.alertFilter,
                "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => ((_ctx.alertFilter) = $event)),
                placeholder: "Filter alerts",
                clearable: ""
              }, {
                prefix: _withCtx(() => [
                  _hoisted_6
                ]),
                _: 1
              }, 8, ["modelValue"]),
              (_ctx.filteredEmergencyAlerts && _ctx.filteredEmergencyAlerts.length)
                ? (_openBlock(), _createElementBlock("ul", _hoisted_7, [
                    _createVNode(_TransitionGroup, { name: "list" }, {
                      default: _withCtx(() => [
                        (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.filteredEmergencyAlerts, (alert) => {
                          return (_openBlock(), _createElementBlock("li", {
                            key: alert.id,
                            class: _normalizeClass(["dt-list__item", { active: _ctx.selectedEmergencyAlert && alert.id == _ctx.selectedEmergencyAlert.id  }])
                          }, [
                            _createVNode(_component_router_link, {
                              class: "alerts__alert-link",
                              to: '/alerts/' + alert.id
                            }, {
                              default: _withCtx(() => [
                                (alert.is_active)
                                  ? (_openBlock(), _createElementBlock("span", _hoisted_8))
                                  : _createCommentVNode("", true),
                                _createElementVNode("div", _hoisted_9, [
                                  _createElementVNode("div", _hoisted_10, _toDisplayString(alert.title), 1),
                                  _createElementVNode("div", _hoisted_11, [
                                    _createElementVNode("span", _hoisted_12, "Sent " + _toDisplayString(_ctx.formatDate(alert.createdAt)) + " UTC", 1)
                                  ])
                                ]),
                                _createVNode(_component_el_tooltip, {
                                  effect: "dark",
                                  content: "Deactivate",
                                  placement: "bottom",
                                  "hide-after": 0,
                                  "show-after": 500
                                }, {
                                  default: _withCtx(() => [
                                    _createElementVNode("div", null, [
                                      (alert.is_active)
                                        ? (_openBlock(), _createElementBlock("button", {
                                            key: 0,
                                            class: "dt-list__item-delete",
                                            onClick: _withModifiers(($event: any) => (_ctx.deactivateAlert(alert)), ["stop","prevent"])
                                          }, _hoisted_15, 8, _hoisted_13))
                                        : _createCommentVNode("", true)
                                    ])
                                  ]),
                                  _: 2
                                }, 1024)
                              ]),
                              _: 2
                            }, 1032, ["to"])
                          ], 2))
                        }), 128))
                      ]),
                      _: 1
                    })
                  ]))
                : (_openBlock(), _createElementBlock("div", _hoisted_16, [
                    _createElementVNode("img", {
                      src: require('../../assets/images/Whats-Mirroring.png')
                    }, null, 8, _hoisted_17),
                    _hoisted_18
                  ]))
            ], 64))
          : (!_ctx.isAlertsLoading && _ctx.alerts.length == 0)
            ? (_openBlock(), _createElementBlock("div", _hoisted_19, _hoisted_21))
            : (_ctx.isAlertsLoading)
              ? _withDirectives((_openBlock(), _createElementBlock("div", _hoisted_22, null, 512)), [
                  [_directive_loading, _ctx.isAlertsLoading]
                ])
              : _createCommentVNode("", true)
      ])
    ]),
    _createElementVNode("section", {
      class: _normalizeClass(["dt-card alerts__details", { active: ((_ctx.selectedEmergencyAlert && _ctx.selectedEmergencyAlert.id) || _ctx.creationMode) }])
    }, [
      ((_ctx.selectedEmergencyAlert && _ctx.selectedEmergencyAlert.id && !_ctx.creationMode) || _ctx.selectedEmergencyAlert && _ctx.creationMode)
        ? (_openBlock(), _createElementBlock(_Fragment, { key: 0 }, [
            _createElementVNode("div", _hoisted_23, [
              _createElementVNode("div", _hoisted_24, [
                _createVNode(_component_el_tooltip, {
                  effect: "dark",
                  content: _ctx.selectedEmergencyAlert.title,
                  placement: "bottom-start",
                  "show-after": 1000
                }, {
                  default: _withCtx(() => [
                    _createElementVNode("h2", _hoisted_25, [
                      (_ctx.selectedEmergencyAlert.title)
                        ? (_openBlock(), _createElementBlock(_Fragment, { key: 0 }, [
                            _createTextVNode(_toDisplayString(_ctx.selectedEmergencyAlert.title), 1)
                          ], 64))
                        : (_openBlock(), _createElementBlock("em", _hoisted_26, "New Alert"))
                    ])
                  ]),
                  _: 1
                }, 8, ["content"])
              ]),
              _createElementVNode("div", null, [
                _createVNode(_component_router_link, { to: "/alerts" }, {
                  default: _withCtx(() => [
                    _createVNode(_component_el_button, { class: "ms-3" }, {
                      default: _withCtx(() => [
                        _createTextVNode("Cancel")
                      ]),
                      _: 1
                    })
                  ]),
                  _: 1
                }),
                (_ctx.creationMode)
                  ? _withDirectives((_openBlock(), _createBlock(_component_el_button, {
                      key: 0,
                      class: "ms-3",
                      type: "primary",
                      onClick: _ctx.createAlert
                    }, {
                      default: _withCtx(() => [
                        _createTextVNode("Create Alert")
                      ]),
                      _: 1
                    }, 8, ["onClick"])), [
                      [_directive_loading, _ctx.alertCreationLoading]
                    ])
                  : _createCommentVNode("", true),
                (_ctx.selectedEmergencyAlert.id && _ctx.selectedEmergencyAlert.is_active)
                  ? (_openBlock(), _createBlock(_component_el_button, {
                      key: 1,
                      class: "alerts__deactivate-button",
                      plain: "",
                      type: "danger",
                      onClick: _cache[1] || (_cache[1] = ($event: any) => (_ctx.deactivateAlert(_ctx.selectedEmergencyAlert)))
                    }, {
                      default: _withCtx(() => [
                        _createTextVNode("Deactivate")
                      ]),
                      _: 1
                    }))
                  : _createCommentVNode("", true)
              ])
            ]),
            _createElementVNode("div", _hoisted_27, [
              _createVNode(_component_el_form, {
                "hide-required-asterisk": "",
                ref: "alertForm",
                rules: _ctx.rules,
                "label-position": "top",
                model: _ctx.selectedEmergencyAlert
              }, {
                default: _withCtx(() => [
                  _createElementVNode("div", _hoisted_28, [
                    (_ctx.selectedEmergencyAlert && _ctx.selectedEmergencyAlert.is_active)
                      ? (_openBlock(), _createElementBlock("span", _hoisted_29, _hoisted_31))
                      : _createCommentVNode("", true),
                    (_ctx.selectedEmergencyAlert && !_ctx.selectedEmergencyAlert.is_active)
                      ? (_openBlock(), _createElementBlock("span", _hoisted_32, _hoisted_34))
                      : _createCommentVNode("", true)
                  ]),
                  _createElementVNode("div", _hoisted_35, [
                    _createElementVNode("div", _hoisted_36, [
                      _createVNode(_component_el_form_item, {
                        prop: "title",
                        label: "Title"
                      }, {
                        default: _withCtx(() => [
                          _hoisted_37,
                          _createVNode(_component_el_input, {
                            disabled: _ctx.selectedEmergencyAlert.id ? 'disabled' : false,
                            modelValue: _ctx.selectedEmergencyAlert.title,
                            "onUpdate:modelValue": _cache[2] || (_cache[2] = ($event: any) => ((_ctx.selectedEmergencyAlert.title) = $event)),
                            placeholder: "Important alert for 121 S Main St"
                          }, null, 8, ["disabled", "modelValue"])
                        ]),
                        _: 1
                      })
                    ]),
                    _createElementVNode("div", _hoisted_38, [
                      _createVNode(_component_el_form_item, {
                        prop: "severity",
                        label: "Severity"
                      }, {
                        default: _withCtx(() => [
                          _hoisted_39,
                          _createVNode(_component_el_select, {
                            modelValue: _ctx.selectedEmergencyAlert.severity,
                            "onUpdate:modelValue": _cache[3] || (_cache[3] = ($event: any) => ((_ctx.selectedEmergencyAlert.severity) = $event)),
                            placeholder: "Severity",
                            disabled: _ctx.selectedEmergencyAlert.id ? 'disabled' : false,
                            onChange: _cache[4] || (_cache[4] = ($event: any) => ($event.stopProgagation()))
                          }, {
                            default: _withCtx(() => [
                              _createVNode(_component_el_option, { value: "Extreme" }, {
                                default: _withCtx(() => [
                                  _createTextVNode("Extreme")
                                ]),
                                _: 1
                              }),
                              _createVNode(_component_el_option, { value: "Severe" }, {
                                default: _withCtx(() => [
                                  _createTextVNode("Severe")
                                ]),
                                _: 1
                              }),
                              _createVNode(_component_el_option, { value: "Moderate" }, {
                                default: _withCtx(() => [
                                  _createTextVNode("Moderate")
                                ]),
                                _: 1
                              }),
                              _createVNode(_component_el_option, { value: "Minor" }, {
                                default: _withCtx(() => [
                                  _createTextVNode("Minor")
                                ]),
                                _: 1
                              }),
                              _createVNode(_component_el_option, { value: "Unknown" }, {
                                default: _withCtx(() => [
                                  _createTextVNode("Unknown")
                                ]),
                                _: 1
                              })
                            ]),
                            _: 1
                          }, 8, ["modelValue", "disabled"])
                        ]),
                        _: 1
                      })
                    ])
                  ]),
                  _createElementVNode("div", _hoisted_40, [
                    _createElementVNode("div", _hoisted_41, [
                      _createVNode(_component_el_form_item, {
                        prop: "effectiveTime",
                        class: "mb-0",
                        label: "Effective Time"
                      }, {
                        default: _withCtx(() => [
                          _hoisted_42,
                          _createVNode(_component_VueDatePicker, {
                            "enable-seconds": true,
                            clearable: false,
                            "hide-input-icon": "",
                            modelValue: _ctx.selectedEmergencyAlert.effectiveTime,
                            "onUpdate:modelValue": _cache[5] || (_cache[5] = ($event: any) => ((_ctx.selectedEmergencyAlert.effectiveTime) = $event)),
                            "is-24": false,
                            "auto-apply": "",
                            "min-time": { hours: 0, minutes: 0, seconds: 1 },
                            position: "left",
                            teleport: true,
                            "menu-class-name": "alert__datetime-picker"
                          }, null, 8, ["modelValue"])
                        ]),
                        _: 1
                      })
                    ]),
                    _createElementVNode("div", _hoisted_43, [
                      _createVNode(_component_el_form_item, {
                        prop: "expirationTime",
                        class: "mb-0",
                        label: "Expiration Time"
                      }, {
                        default: _withCtx(() => [
                          _hoisted_44,
                          _createVNode(_component_VueDatePicker, {
                            "enable-seconds": true,
                            clearable: false,
                            "hide-input-icon": "",
                            modelValue: _ctx.selectedEmergencyAlert.expirationTime,
                            "onUpdate:modelValue": _cache[6] || (_cache[6] = ($event: any) => ((_ctx.selectedEmergencyAlert.expirationTime) = $event)),
                            "is-24": false,
                            "auto-apply": "",
                            "min-time": { hours: 0, minutes: 0, seconds: 1 },
                            position: "left",
                            teleport: true,
                            "menu-class-name": "alert__datetime-picker"
                          }, null, 8, ["modelValue"])
                        ]),
                        _: 1
                      })
                    ])
                  ]),
                  _hoisted_45,
                  _createElementVNode("div", _hoisted_46, [
                    _createElementVNode("div", _hoisted_47, [
                      _createVNode(_component_el_form_item, {
                        prop: "description",
                        class: "mb-lg-0",
                        label: "Description"
                      }, {
                        default: _withCtx(() => [
                          _hoisted_48,
                          _createVNode(_component_el_input, {
                            disabled: _ctx.selectedEmergencyAlert.id ? 'disabled' : false,
                            modelValue: _ctx.selectedEmergencyAlert.description,
                            "onUpdate:modelValue": _cache[7] || (_cache[7] = ($event: any) => ((_ctx.selectedEmergencyAlert.description) = $event)),
                            height: { minRows: 2 },
                            type: "textarea",
                            placeholder: "Severe weather is expected to impact the area at 4:45 p.m."
                          }, null, 8, ["disabled", "modelValue"])
                        ]),
                        _: 1
                      })
                    ]),
                    _hoisted_49
                  ]),
                  _createVNode(_component_el_divider),
                  _createElementVNode("div", _hoisted_50, [
                    _createVNode(_component_Icon, { icon: _ctx.mdiLightbulb }, null, 8, ["icon"]),
                    _hoisted_51
                  ]),
                  _createElementVNode("div", _hoisted_52, [
                    _createElementVNode("div", _hoisted_53, [
                      _createVNode(_component_el_form_item, {
                        ref: "rooms",
                        class: "mb-lg-0",
                        label: "Rooms",
                        prop: "rooms"
                      }, {
                        default: _withCtx(() => [
                          _hoisted_54,
                          _createVNode(_component_el_button, {
                            type: "primary",
                            onClick: _ctx.manageRoomsClickHandler
                          }, {
                            default: _withCtx(() => [
                              _createTextVNode(_toDisplayString(_ctx.selectedEmergencyAlert.rooms && _ctx.selectedEmergencyAlert.rooms.length ? _ctx.selectedEmergencyAlert.rooms.length: 0) + " Rooms", 1)
                            ]),
                            _: 1
                          }, 8, ["onClick"])
                        ]),
                        _: 1
                      }, 512)
                    ]),
                    _createElementVNode("div", _hoisted_55, [
                      _createVNode(_component_el_form_item, {
                        ref: "locations",
                        class: "mb-0",
                        label: "Locations",
                        prop: "locations"
                      }, {
                        default: _withCtx(() => [
                          (_ctx.selectedEmergencyAlert.id)
                            ? (_openBlock(), _createElementBlock("span", _hoisted_56, "Locations are translated into rooms for this alert."))
                            : (_openBlock(), _createElementBlock(_Fragment, { key: 1 }, [
                                _hoisted_57,
                                _createVNode(_component_el_button, {
                                  type: "primary",
                                  onClick: _ctx.manageLocationsClickHandler
                                }, {
                                  default: _withCtx(() => [
                                    _createTextVNode(_toDisplayString(_ctx.selectedEmergencyAlert.locations && _ctx.selectedEmergencyAlert.locations.length ? _ctx.selectedEmergencyAlert.locations.length : 0) + " Locations", 1)
                                  ]),
                                  _: 1
                                }, 8, ["onClick"])
                              ], 64))
                        ]),
                        _: 1
                      }, 512)
                    ])
                  ]),
                  (_ctx.selectedEmergencyAlert.id)
                    ? (_openBlock(), _createElementBlock(_Fragment, { key: 0 }, [
                        _createVNode(_component_el_divider),
                        _createElementVNode("div", _hoisted_58, [
                          _createElementVNode("div", _hoisted_59, [
                            _createVNode(_component_el_form_item, {
                              label: "Identifier",
                              prop: "alertIdentifier"
                            }, {
                              default: _withCtx(() => [
                                _createElementVNode("span", _hoisted_60, _toDisplayString(_ctx.selectedEmergencyAlert.identifier), 1)
                              ]),
                              _: 1
                            })
                          ]),
                          _createElementVNode("div", _hoisted_61, [
                            _createVNode(_component_el_form_item, {
                              label: "Date Created (UTC)",
                              prop: "alertCreatedAt"
                            }, {
                              default: _withCtx(() => [
                                _createElementVNode("span", null, _toDisplayString(_ctx.formatDate(_ctx.selectedEmergencyAlert.createdAt.toString())), 1)
                              ]),
                              _: 1
                            })
                          ])
                        ]),
                        _createElementVNode("div", _hoisted_62, [
                          _createElementVNode("div", _hoisted_63, [
                            _createVNode(_component_el_form_item, {
                              label: "Skip Reasons",
                              prop: "alertSkipReasons"
                            }, {
                              default: _withCtx(() => [
                                (_ctx.selectedEmergencyAlert.skipReason && _ctx.selectedEmergencyAlert.skipReason.length)
                                  ? (_openBlock(), _createElementBlock("ul", _hoisted_64, [
                                      (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.selectedEmergencyAlert.skipReason, (reason, index) => {
                                        return (_openBlock(), _createElementBlock("li", { key: index }, _toDisplayString(reason), 1))
                                      }), 128))
                                    ]))
                                  : (_openBlock(), _createElementBlock("span", _hoisted_65, "No skip reasons"))
                              ]),
                              _: 1
                            })
                          ]),
                          _createElementVNode("div", _hoisted_66, [
                            _createVNode(_component_el_form_item, {
                              label: "Activate Reasons",
                              prop: "alertActivateReason"
                            }, {
                              default: _withCtx(() => [
                                (_ctx.selectedEmergencyAlert.activateReason && _ctx.selectedEmergencyAlert.activateReason.length)
                                  ? (_openBlock(), _createElementBlock("ul", _hoisted_67, [
                                      (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.selectedEmergencyAlert.activateReason, (reason, index) => {
                                        return (_openBlock(), _createElementBlock("li", { key: index }, _toDisplayString(reason), 1))
                                      }), 128))
                                    ]))
                                  : (_openBlock(), _createElementBlock("span", _hoisted_68, "No activate reasons"))
                              ]),
                              _: 1
                            })
                          ])
                        ]),
                        _createElementVNode("div", _hoisted_69, [
                          _createElementVNode("div", _hoisted_70, [
                            _createVNode(_component_el_form_item, {
                              label: "Deactivate Reasons",
                              prop: "alertDeactivateReason"
                            }, {
                              default: _withCtx(() => [
                                (_ctx.selectedEmergencyAlert.deactivateReason && _ctx.selectedEmergencyAlert.deactivateReason.length)
                                  ? (_openBlock(), _createElementBlock("ul", _hoisted_71, [
                                      (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.selectedEmergencyAlert.deactivateReason, (reason, index) => {
                                        return (_openBlock(), _createElementBlock("li", { key: index }, _toDisplayString(reason), 1))
                                      }), 128))
                                    ]))
                                  : (_openBlock(), _createElementBlock("span", _hoisted_72, "No deactivate reasons"))
                              ]),
                              _: 1
                            })
                          ])
                        ])
                      ], 64))
                    : _createCommentVNode("", true)
                ]),
                _: 1
              }, 8, ["rules", "model"])
            ], 512)
          ], 64))
        : (_ctx.isAlertDetailsLoading)
          ? _withDirectives((_openBlock(), _createElementBlock("div", _hoisted_73, null, 512)), [
              [_directive_loading, _ctx.isAlertDetailsLoading]
            ])
          : (_openBlock(), _createElementBlock("div", _hoisted_74, [
              (_ctx.$route.params.id && !_ctx.selectedEmergencyAlert)
                ? (_openBlock(), _createElementBlock("p", _hoisted_75, "Alert not found."))
                : _createCommentVNode("", true),
              _hoisted_76
            ]))
    ], 2),
    (_ctx.selectedEmergencyAlert)
      ? (_openBlock(), _createBlock(_component_ModelSelector, {
          key: 0,
          "includes-all": true,
          title: "Add Rooms to Alert",
          subTitle: _ctx.selectedEmergencyAlert.title ? _ctx.selectedEmergencyAlert.title : 'New Alert',
          modelTypeName: "rooms",
          onSelectionPoolChange: _ctx.roomSelectionChanged,
          ref: "roomModelSelector",
          hideSaveButton: !_ctx.creationMode
        }, null, 8, ["subTitle", "onSelectionPoolChange", "hideSaveButton"]))
      : _createCommentVNode("", true),
    (_ctx.selectedEmergencyAlert)
      ? (_openBlock(), _createBlock(_component_ModelSelector, {
          key: 1,
          "includes-all": true,
          title: "Add Locations to Alert",
          subTitle: _ctx.selectedEmergencyAlert.title ? _ctx.selectedEmergencyAlert.title : 'New Alert',
          modelTypeName: "locations",
          onSelectionPoolChange: _ctx.locationSelectionChanged,
          ref: "locationModelSelector",
          hideSaveButton: !_ctx.creationMode
        }, null, 8, ["subTitle", "onSelectionPoolChange", "hideSaveButton"]))
      : _createCommentVNode("", true),
    _createVNode(_component_TierLimit, {
      modelValue: _ctx.showTierCallout,
      "onUpdate:modelValue": _cache[8] || (_cache[8] = ($event: any) => ((_ctx.showTierCallout) = $event)),
      isCallout: false,
      isLimit: false,
      message: "Upgrade your Ditto account to unlock alerts."
    }, null, 8, ["modelValue"])
  ]))
}